import React, { Component, Fragment } from "react";
import { CirclePicker } from "react-color";
import styled from "styled-components";
import conic from "../../assets/conic.png";
import { FormattedMessage } from "react-intl";

const Button = styled.button`
  border: none;
  color: #fff;
  font-weight: bold;
  width: 20px;
  height: 20px;
  background-image: url(${conic});
  background-size: contain;
  background-color: transparent;
  border-radius: 20px;
`;

const PickWrapper = styled.div`
  text-align: center;
  position: relative;
  .circle-picker {
    width: 30vw !important;
    align-items: center;
    justify-content: center;
    padding: 12px;
    position: absolute;
    bottom: -100px;
    right: 0;
    z-index: 999;
    background: #ffffffa1;
    span > div {
      margin-bottom: 0 !important;
    }
    @media (max-width: 768px) {
      bottom: auto;
      top: -75px;
      right: -10vw;
      z-index: 999;
      width: 100vw !important;
      background: #ffffffa1;
      z-index: 9999;
    }
  }
  .vertical {
    font-weight: bold;
    font-size: 12px;
    background: #fff;
    line-height: 18px;
    padding: 12px;
    white-space: nowrap;
    z-index: 1;
  }
`;

class ColorField extends Component {
  colors = ["#8e402a", "#0e4235", "#9da1aa", "#2773b1", "#658159", "#d53132"];
  onChange = data => {
    this.props.form.setFieldValue(this.props.field.name, data.hex);
  };
  state = {
    show: false,
  };

  revealPicker = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  render() {
    return (
      <Fragment>
        <span>
          <FormattedMessage id="color.title" defaultMessage="Kolor" />
        </span>
        <Button type="button" onClick={this.revealPicker} />
        {this.state.show ? (
          <PickWrapper>
            <CirclePicker
              colors={this.colors}
              onChangeComplete={this.onChange}
            />
          </PickWrapper>
        ) : null}
      </Fragment>
    );
  }
}

export default ColorField;
